Monitoring.Views ||= {}

class Monitoring.Views.MovistarIntervalsListView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_intervals_list"]

  events:
    'click #add-interval': 'onClickAddInterval'
    'click .edit-interval': 'onClickEditInterval'
    'click .delete-interval': 'onClickDeleteInterval'


  initialize: (@options = {}) ->
    @intervals = @options.intervals

  render: =>
    @$el.html(@template(@))
    @

  onClickAddInterval: ->
    @renderIntervalEdit()

  onClickEditInterval: (evt) ->
    intervalId = $(evt.currentTarget).data('cid')
    intervalToEdit = @intervals.get(intervalId)
    @renderIntervalEdit(intervalToEdit)


  onClickDeleteInterval: (evt) ->
    swal({
      title: I18n.t('monitoring.rules.confirmation.are_you_sure')
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t('monitoring.rules.confirmation.confirm')
      cancelButtonText: I18n.t('monitoring.rules.confirmation.cancel')
      closeOnConfirm: true
    }, =>
      intervalToDelete = $(evt.currentTarget).data('cid')
      @intervals.remove(intervalToDelete)
      @trigger('changed-mandatory-field')
      @render()
    )

  renderIntervalEdit: (interval = new Monitoring.Models.MovistarRuleInterval) ->
    @editIntervalView.remove() if @editIntervalView
    @editIntervalView = new Monitoring.Views.MovistarIntervalEditView({
      interval: interval
    })
    @$el.find('.edit-view-container').html(@editIntervalView.render().el)
    @listenTo(@editIntervalView, 'afterSaveInterval', @afterSaveInterval)

  afterSaveInterval: (newInterval) ->
    @intervals.push(newInterval)
    @trigger('changed-mandatory-field')
    @render()

  getIntervals: ->
    @intervals

  getStartDate: ->
    minDate = @intervals.models[0].get('start_date')
    _.each(@intervals.models, (interval, i) =>
      if interval.get('active') && interval.get('start_date') < minDate
        minDate = interval.get('start_date')
    )
    minDate

  getEndDate: ->
    notEndingIntervalPresent = _.some @intervals.models, (interval) -> interval.get('active') && !interval.get('end_date')
    return undefined if notEndingIntervalPresent
    maxDate = @intervals.models[0].get('end_date')
    _.each(@intervals.models, (interval, i) =>
      if interval.get('active') && interval.get('end_date') > maxDate
        maxDate = interval.get('end_date')
    )
    maxDate

  allMandatoryFieldsAreFilled: =>
    @intervals.models.length > 0
